import { useFlag } from "@unleash/nextjs"

export const useIsSocialLoginEnabled = () => {
  return useFlag("is_social_login_enabled")
}

export const useCreateEmbeddedWalletManual = () => {
  return useFlag("create_embedded_wallet_manual")
}
